import { KeyDict } from '@/types'
import { Notification } from '@/types/admin'
import Vue from 'vue'

export default Vue.extend({
  computed: {
    notifications (): KeyDict<Notification> | null {
      const notifications = this.$store.direct.state.admin.notifications
      return notifications
    },
  },
  mounted () {
    this.$store.direct.dispatch.admin.subscribeAdminProperties()
  },
  beforeDestroy () {
    this.$store.direct.dispatch.admin.unsubscribeAdminProperties()
  }
})
